import React from 'react';

import { Field } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';

import { TextFieldWrapper } from './TextField.styled';

export const TextFieldView = ({
  input,
  meta,
  isRequired,
  label,
  placeholder,
}: any) => {
  return (
    <TextFieldWrapper hasLabel={!!label}>
      <Field label={label} isRequired={isRequired} name={input.name}>
        {() => (
          <Textfield
            value={input.value}
            placeholder={placeholder}
            isInvalid={meta.touched && !!meta.error}
            onChange={input.onChange}
          />
        )}
      </Field>
    </TextFieldWrapper>
  );
};
